// Content remains visible without JS or IntersectionObserver. Reveal only once.
const motionPreference=matchMedia('(prefers-reduced-motion: reduce)');
let revealObserver;
function setupMotion(){
  if(revealObserver)revealObserver.disconnect();
  document.querySelectorAll('.reveal-pending').forEach(el=>el.classList.remove('reveal-pending'));
  document.body.classList.toggle('motion-ready',!motionPreference.matches);
  if(motionPreference.matches||!('IntersectionObserver' in window))return;
  const targets=document.querySelectorAll('.about-heading,.about-reveal,.section>h2,.news-card,.feature,.category,.product-card,.tech-grid figure,.tech-description,.project-grid article,.section>.outline,footer>div,footer>nav');
  document.querySelectorAll('.news-grid,.category-grid,.product-grid,.tech-grid,.project-grid').forEach(grid=>{
    const children=[...grid.children];
    const rows=new Map();
    children.forEach(el=>{const top=Math.round(el.getBoundingClientRect().top);const column=rows.get(top)||0;el.style.setProperty('--reveal-delay',Math.min(column*90,270)+'ms');rows.set(top,column+1);});
  });
  revealObserver=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      entry.target.classList.remove('reveal-pending');
      revealObserver.unobserve(entry.target);
    });
  },{threshold:0,rootMargin:'0px 0px -4% 0px'});
  targets.forEach(el=>{
    el.classList.add('motion-reveal');
    if(el.getBoundingClientRect().top>=window.innerHeight*.96){
      el.classList.add('reveal-pending');revealObserver.observe(el);
    }
  });
}
setupMotion();
motionPreference.addEventListener('change',setupMotion);
// Keyboard navigation must not leave a focused control invisible.
document.addEventListener('focusin',e=>{
  const el=e.target.closest('.reveal-pending');
  if(el){el.classList.remove('reveal-pending');revealObserver?.unobserve(el);}
});



document.addEventListener("shopify:section:load",setupMotion);
